import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { getProduct } from "../../config/products";
import { BuyButton } from "./BuyButton";
import { CAD } from "../../lib/format";
import { analytics } from "../../lib/analytics/ga4";

// Contextual recommendation shown beside/below a calculator result.
export default function ProductRecommendation({ productId, calculatorName }) {
  const product = getProduct(productId);
  useEffect(() => { if (product) analytics.productView(product.id); }, [product]);
  if (!product) return null;

  return (
    <div data-testid="product-recommendation" className="overflow-hidden rounded-2xl bg-brand-soft p-6">
      <div className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-brand">
        <Sparkles className="h-4 w-4" /> Take it further
      </div>
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <img src={product.image} alt={product.name} loading="lazy" className="h-20 w-20 shrink-0 rounded-xl object-cover" />
        <div className="flex-1">
          <h4 className="font-heading text-lg font-bold text-brand">{product.name}</h4>
          <p className="text-sm text-brand/80">
            {calculatorName ? `Loved this ${calculatorName.replace(" Calculator", "")} tool? ` : ""}{product.tagline}.
          </p>
        </div>
      </div>
      <div className="mt-5 flex flex-wrap items-center gap-3">
        <BuyButton product={product} />
        <Link to={`/products/${product.id}`} className="inline-flex items-center gap-1 text-sm font-semibold text-brand transition-colors hover:text-action" data-testid="recommendation-details">
          See what's inside <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      <p className="mt-3 text-xs text-brand/70">Instant download · {CAD(product.price)} CAD · Secure checkout by Stripe</p>
    </div>
  );
}
